import { render, staticRenderFns } from "./GeneralTableView.vue?vue&type=template&id=65ef1957&scoped=true&"
import script from "./GeneralTableView.vue?vue&type=script&lang=js&"
export * from "./GeneralTableView.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTableView.vue?vue&type=style&index=0&id=65ef1957&scoped=true&lang=css&"
import style1 from "./GeneralTableView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef1957",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ef1957')) {
      api.createRecord('65ef1957', component.options)
    } else {
      api.reload('65ef1957', component.options)
    }
    module.hot.accept("./GeneralTableView.vue?vue&type=template&id=65ef1957&scoped=true&", function () {
      api.rerender('65ef1957', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableView/GeneralTableView.vue"
export default component.exports